module.exports = __webpack_public_path__ + "img/1557614092365144067.1d9680d5.png";